export default __webpack_public_path__ + "74699e2361fabcef3a43fa906297eeb8.png";